module.exports = __webpack_public_path__ + "img/providerexample.f53755f8.png";